import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { DASHBOARD_AUDIENCE } from 'constants/kpiBuilderCatalogue';
import { builderIssuesState, visualisationDashboardsState, visualisationRolesState } from 'states';
import { validate } from 'helpers/kpiBuilder/validation';
import { BuilderAnswers } from 'helpers/kpiBuilder/types';

/**
 * Warnings for the banners. Errors (missing title, no roles, unfinished data) are already
 * reported by the editor's own validation, so only warnings are shown here.
 */
export function useBuilderIssues(answers: BuilderAnswers, title: string, builderMode: boolean): void {
  const roles = useRecoilValue(visualisationRolesState);
  const dashboards = useRecoilValue(visualisationDashboardsState);
  const setIssues = useSetRecoilState(builderIssuesState);

  useEffect(() => {
    const issues = validate(answers, {
      title,
      roles: roles.map((r) => r.code ?? ''),
      dashboards: dashboards.map((d) => ({ id: d.dashboardId, label: d.title ?? d.dashboardId, audience: DASHBOARD_AUDIENCE[d.dashboardId] ?? 'any' })),
      codeTaken: false,
    });
    setIssues(builderMode ? issues.filter((i) => i.level === 'warning') : []);
  }, [answers, title, roles, dashboards, builderMode, setIssues]);
}
